import classnames from 'classnames';
import {
  LeagueTables,
  StandingsRow,
  positionFormatter,
} from '@stadionhq-v3/football-ui';
import { Suspense } from 'react';
import { LoadingTemplate } from '@components/templates/loading-template';
import { ClientLeagueTablesProps } from './clientLeagueTables.types';
import styles from './clientLeagueTables.module.scss';

const ClientLeagueTables = ({
  classNames,
  ...props
}: ClientLeagueTablesProps) => {
  const classes = classnames([styles.clientLeagueTables, classNames]);

  return (
    <Suspense fallback={<LoadingTemplate label="Loading" />}>
      <LeagueTables
        classNames={[classes]}
        {...props}
        /*
          NOTE: this is for ATOM that has the positions and position change
                icons in a row
        */
        formatters={{
          position: (row: StandingsRow) => ({
            node: positionFormatter('row')(row),
          }),
        }}
      />
    </Suspense>
  );
};

export default ClientLeagueTables;
